export default __webpack_public_path__ + "static/media/Monk's Hood of the Underworld.83a1c824.jpg";